import styled, { css } from 'styled-components';

import {
    floorGameColor as color,
    CommonAction,
    floorGameDuration as duration,
    floorGameEasing as easing,
    recipesCommonAction,
    styledReset,
    styledTypography,
} from '@pkg/primitives';

import { tokens } from './tokens';
import { type DataChipSuffixType } from './types';

interface SuffixProps {
    $type?: DataChipSuffixType;
}

const typographyBase = css`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.chip.fontSize}px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.02em;
    color: rgb(255, 255, 255, 0.5);
`;

const dataChipBase = css`
    ${styledReset.borderBox};
    display: grid;
    grid-auto-flow: column;
    align-content: center;
    gap: ${tokens.chip.gap}px;
    padding-left: ${tokens.chip.padding}px;
    padding-right: ${tokens.chip.padding}px;
    height: ${tokens.chip.height}px;
    border: 1px solid rgb(255, 255, 255, 0.5);
    border-radius: 999px;
`;

export const DataChipStatic = styled.div`
    ${dataChipBase};
`;

export const DataChipButton = styled(CommonAction)`
    ${dataChipBase};
    ${recipesCommonAction.basic};
    background-color: transparent;

    &[aria-pressed] {
        background-color: rgb(255, 255, 255, 0.1);
    }

    &:disabled {
        opacity: 0.8;
    }

    &:hover:not(:active) {
        background-color: rgb(255, 255, 255, 0.1);
    }
`;

export const Label = styled.p`
    ${typographyBase};
`;

export const Value = styled.p`
    ${typographyBase};
    color: white;
`;

export const Suffix = styled.p<SuffixProps>`
    ${typographyBase};
    transition: color ${duration.normal}ms ${easing.cubic};

    ${({ $type }) => {
        if ($type === 'positive') {
            return css`
                color: ${color.green};
            `;
        }

        if ($type === 'negative') {
            return css`
                color: ${color.red};
            `;
        }
    }};
`;

export const EmptyState = styled.p`
    ${typographyBase};
`;

///
/// List

interface StyledDataChipListProps {
    $wrap?: boolean;
}

export const StyledDataChipList = styled.ul<StyledDataChipListProps>`
    ${styledReset.list};
    display: flex;
    flex-wrap: ${({ $wrap }) => ($wrap ? 'wrap' : undefined)};
    gap: ${tokens.list.gap}px;
`;

export const StyledItem = styled.li`
    flex: 0 0 auto;
`;
